import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify/lib/framework';
import App from './App.vue';
import { initializeApp } from 'firebase/app';
import { getFirestore, QuerySnapshot } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import config from './config';
import axios from 'axios';
axios.defaults.baseURL = 'https://taiwantrip.v2.backend.newfields.com.tw/';
// axios.defaults.baseURL = 'http://localhost:5501';
axios.defaults.headers.common['Content-Type'] = 'application/json';
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(Vuetify);
initializeApp(config);
export const vuetify = new Vuetify({ iconfont: 'md' });
export const bus = new Vue();
export const db = getFirestore();
export const auth = getAuth();
export const isObject = (obj)=> typeof obj == 'object' && obj !== null;
export function shot2docs(querySnapshot = new QuerySnapshot()) {
    const docs = [];
    querySnapshot.forEach((doc) => docs.push({ _id: doc.id, ...doc.data() }));
    return docs;
}
const router = new VueRouter({
    mode: 'history',
    base: process.env.Base_URL,
    routes: [
        { path: '*', redirect: '/login' },
        { path: '/', redirect: '/login' },
        { path: '/login', name: 'login', component: () => import('./pages/login.vue') },
        { path: '/schedule', name: 'schedule', component: () => import('./pages/schedule.vue') },
        { path: '/checkin', name: 'checkin', component: () => import('./pages/checkin.vue') },
        { path: '/settings', name: 'settings', component: () => import('./pages/settings.vue') },
        { path: '/design', name: 'design', component: () => import('./pages/design.vue') },
        { path: '/trace', name: 'trace', component: () => import('./pages/trace.vue') },
        { path: '/result', name: 'result', component: () => import('./pages/result.vue') },
        { path: '/record', name: 'record', component: () => import('./pages/record.vue') },
        { path: '/write', name: 'write', component: () => import('./pages/write.vue') },
    ],
});
export const colors = [
    { p: '#f44336', l: '#ffcdd2', d: '#b71c1c' },
    { p: '#e91e63', l: '#f8bbd0', d: '#880e4f' },
    { p: '#9c27b0', l: '#e1bee7', d: '#4a148c' },
    { p: '#673ab7', l: '#d1c4e9', d: '#311b92' },
    { p: '#3f51b5', l: '#c5cae9', d: '#1a237e' },
    { p: '#2196f3', l: '#bbdefb', d: '#0d47a1' },
    { p: '#03a9f4', l: '#b3e5fc', d: '#01579b' },
    { p: '#00bcd4', l: '#b2ebf2', d: '#006064' },
    { p: '#009688', l: '#b2dfdb', d: '#004d40' },
    { p: '#4caf50', l: '#c8e6c9', d: '#1b5e20' },
    { p: '#8bc34a', l: '#dcedc8', d: '#33691e' },
    { p: '#cddc39', l: '#f0f4c3', d: '#827717' },
    { p: '#ffeb3b', l: '#fff9c4', d: '#f57f17' },
    { p: '#ffc107', l: '#ffecb3', d: '#ff6f00' },
    { p: '#ff9800', l: '#ffe0b2', d: '#e65100' },
    { p: '#ff5722', l: '#ffccbc', d: '#bf360c' },
    { p: '#795548', l: '#d7ccc8', d: '#3e2723' },
    { p: '#9e9e9e', l: '#f5f5f5', d: '#212121' },
    { p: '#607d8b', l: '#cfd8dc', d: '#263238' },
];
export const store = new Vuex.Store({
    state: {
        user: null,
        selectedYear: null, 
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
        setSelectedYear(state, payload) { 
            state.selectedYear = payload;
        },
    },
});
let app;
auth.onAuthStateChanged(() => {
    if(!app) app = new Vue({ vuetify, store, router, render: (x) => x(App) }).$mount('#app');
});
axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);